import React from "react"
import "./src/styles/index.scss"
import { loadCdnScripts } from "@ecom/ui/utils/api"

export const onClientEntry = () => {
  loadCdnScripts()
}

export const wrapPageElement = ({ element }) => {
  return element
}
